import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"

import { jewlr_t } from "helpers/application"

export default function withDetails(WrappedComponent) {
  const InternalProductDetails = (props) => {
    return <WrappedComponent {...props} />
  }

  const mapStateToProps = (state) => {
    let details = [
      {
        key: "shipping",
        title: jewlr_t("terms.Shipping"),
      },
      { key: "returns", title: "Returns & Warranty" },
      {
        content: {
          specs: [],
          text: "",
        },
        key: "description",
        title: "Description",
      },
    ]
    // Add details content from state
    if (Object.keys(state.wizard.description).length > 0) {
      details[2].content.text = state.wizard.description.product_description
      details[2].content.specs = state.wizard.description.specs
    }

    return {
      description: state.wizard.description,
      details,
      pricing: state.wizardUI.currentPricing,
    }
  }

  const mapDispatchToProps = () => {
    return {}
  }

  InternalProductDetails.propTypes = {
    description: PropTypes.object,
    details: PropTypes.array,
    pricing: PropTypes.object,
  }

  const ProductDetails = connect(
    mapStateToProps,
    mapDispatchToProps
  )(InternalProductDetails)

  return ProductDetails
}
